module.exports = __webpack_public_path__ + "static/img/paypal.fdecc814.png";